<template>
  <div class="articles p-5">
    <h1 class="font-weight-bolder  mt-5">Articles Section  </h1>
    <p class="mt-5" > Write is one of my favorite hobbies, sometimes when inspirations came, 
      i spend a part of  my time to create short articles to help people,
       when they decide to jump into programming world. These articles are written on my native language (Spanish)</p>
    <h2 class="font-weight-bolder  pt-5">El mundo de los audidactas</h2>
      <ul class="mt-5">
        <router-link to="/charpter1"> <li>Capitulo 1</li></router-link>
        <router-link to="/charpter2"> <li>Capitulo 2</li></router-link>
        <router-link to="/charpter3"> <li>Capitulo 3</li></router-link>
     
      
      </ul>
   
  </div>
</template>
<script>


export default {
  name: "Articles",
  
  components: {
    
  }
};
</script>
<style lang="scss" scoped>
p,li{
  
  font-size: 20px;;

}
</style>